export const env = {
  apiUrl: "http://accounting-service.estock-dev.svc.cluster.local",
  signWidgetUrl: "https://test.id.gov.ua/sign-widget/v2022testnew/",
  realmClientId: "estock-ui-client",
  realmUrl: "https://iam-dev.es.mpu.gov.ua/auth/realms/eStock",
  activeLocale: "uk",
  eStockHomePage: "https://estock-dev.es.mpu.gov.ua/",
  zozRedirectUrl: "https://estock-dev.es.mpu.gov.ua/uk/reject/reject-zoz",
};
